import SurveyList from "./SurveyList";

export default SurveyList;
